import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';
import AppConstants from 'src/app/shared/common-components/AppConstants';

@Injectable({
  providedIn: 'root'
})
export class ShipmentReviewService extends DataService {

  public observable$: any;

  constructor(http: HttpClient) {
    super(http);
    this.setUri(this.baseURI);
  }

  private baseURI = this.apiUri + '/bookShipments/shipmentReview/';

  // Function to get the Shipment Review list by shipmentType
  // getShipmentReviewListByShipmentType(shipmentType: string, status: string, orgId: number): Observable<any> {
  //   const shipmentReviewListUrl = this.baseURI + shipmentType + '/shipmentType/' + orgId + '/organizationId/' + status + '/status';
  //   this.setUri(shipmentReviewListUrl);
  //   return this.get();
  // }

  getShipmentReviewListByShipmentType(shipmentType: string, status: string, orgId: number, carrierId: number): Observable<any> {
    const shipmentReviewListUrl = this.baseURI + shipmentType + '/shipmentType/' + orgId + '/organizationId/' + status + '/status/' + carrierId + '/carrierId';
    this.setUri(shipmentReviewListUrl);
    return this.get();
  }

  /**
   * @description formats the value into comma seperator number (in thousands place) and adds $ sign to it.
   */
  formatNumber(params) {
    const number = params.value;
    if (AppConstants.isNotNullCondition(params.value)) {
      const parts = params.value.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    } else {
      return '';
    }
    // return '$' + Math.floor(number).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
// this.carrierID, this.agencyMasterID, this.beginDate, this.endDate
  getFRTShipmentForComprehensiveReport(carrierId: number, beginDate: Number, endDate: Number, agencyMasterID: number): Observable<any> {
    const frtComprehensiveShipmentReport = this.apiUri  + '/bookShipments/frtcomprehensivereport/' + carrierId + '/carrierId/' + beginDate + '/' + endDate + '/' + agencyMasterID;
    this.setUri(frtComprehensiveShipmentReport);
    return this.get();
  }

  getShipmentPodShipmentType(status: string, orgId: number, carrierId: number): Observable<any> {
    const shipmentPodListUrl = this.apiUri  + '/bookShipments/shipmentpod/' + orgId + '/organizationId/' + status + '/status/' + carrierId + '/carrierId';
    this.setUri(shipmentPodListUrl);
    return this.get();
  }
  
}
